import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQueryWithReauth } from './utils.ts'
import { BOLT_BACKEND_TAGS } from './constants.ts'

export const boltBackend = createApi({
  reducerPath: 'boltBackend',
  baseQuery: baseQueryWithReauth,
  tagTypes: Object.values(BOLT_BACKEND_TAGS),
  endpoints: () => ({}) // Endpoints are injected in the subfolders. Naming is based on the API route.
})
